<app-insights-header [isTradingVolumeSelected]="isTradingVolumeSelected"
                     [positionOverviewFilter]="positionOverviewFilter"
                     (onFilterClosed)="filterChanged($event)" />

@if ({totalVolumes: positionsOverviewTotalVolume$ | async,
nrOfTrades: positionsOverviewNrOfTrades$ | async }; as groupedPositionsOverview) {
  @if (!isVolumeChartLoading && !isTotalChartLoading && !showNoTrades) {
    <div class="chart-row">
      <swiper-container #swiper
                        slides-per-view="1"
                        [pagination]="true">
        <swiper-slide>
          <app-currency-doughnut-chart [positionsOverview]="groupedPositionsOverview.totalVolumes"
                                       [colors]="colors"
                                       [selectedSegmentIndex]="selectedSegmentIndex"
                                       [volume]="true"
                                       [totalNumberOfTrades]="totalNumberOfTrades"
                                       [totalVolume]="totalVolume"
                                       [parsingKey]="tradingVolumeParsingKey"
                                       (clickSegment)="onSegmentClicked($event)" />
        </swiper-slide>
        <swiper-slide>
          <app-currency-doughnut-chart [positionsOverview]="groupedPositionsOverview.nrOfTrades"
                                       [colors]="colors"
                                       [selectedSegmentIndex]="selectedSegmentIndex"
                                       [volume]="false"
                                       [totalNumberOfTrades]="totalNumberOfTrades"
                                       [totalVolume]="totalVolume"
                                       [parsingKey]="numberOfTradesParsingKey"
                                       (clickSegment)="onSegmentClicked($event)" />
        </swiper-slide>
      </swiper-container>
    </div>
  }
}
@if (isVolumeChartLoading &&isTotalChartLoading) {
  <ion-spinner name="crescent" />
}
@if (showNoTrades) {
  <div class="empty-chart-wrap">
    <ion-icon src="assets/icon/empty_doughnut.svg"
              class="empty-doughnut" />
  </div>
}
@if (filterPeriods$ | async; as filterPeriods) {
  <app-insights-dates-label [positionOverviewFilter]="positionOverviewFilter"
                            [filterPeriods]="filterPeriods" />
}
@if (!isVolumeChartLoading && !showNoTrades) {
  <ion-content [scrollY]="!isVolumeChartLoading"
               [class.scroll-container]="!isVolumeChartLoading"
               [scrollEvents]="true">
    <ng-container>
      <ion-list>
        @if (!isTradingVolumeSelected) {
          @for (positionOverview of nrOfTradesPositionsOverview; track $index) {
            <app-currency-analytic-card [index]="$index"
                                        [positionOverview]="positionOverview"
                                        [positionOverviewFilter]="positionOverviewFilter"
                                        [highlight]="$index === selectedSegmentIndex
                                                      || (selectedSegmentIndex >= 4 && $index >= 4)"
                                        [highlightColor]="isDefined(colors[selectedSegmentIndex])
                                                      ? colors[selectedSegmentIndex]
                                                      : colors[colors.length - 1]"
                                        [numberOfTrades]="!isTradingVolumeSelected"
                                        [volume]="isTradingVolumeSelected"
                                        (cardClick)="onCardClicked($event)" />
          }
        } @else {
          @for (positionOverview of totalVolumesPositionsOverview; track $index) {
            <app-currency-analytic-card [index]="$index"
                                        [positionOverview]="positionOverview"
                                        [positionOverviewFilter]="positionOverviewFilter"
                                        [highlight]="$index === selectedSegmentIndex
                                                      || (selectedSegmentIndex >= 4 && $index >= 4)"
                                        [highlightColor]="isDefined(colors[selectedSegmentIndex])
                                                      ? colors[selectedSegmentIndex]
                                                      : colors[colors.length - 1] "
                                        [numberOfTrades]="!isTradingVolumeSelected"
                                        [volume]="isTradingVolumeSelected"
                                        (cardClick)="onCardClicked($event)" />
          }
        }
      </ion-list>
    </ng-container>
  </ion-content>
}

@if (!isVolumeChartLoading && showNoTrades) {
  <div class="ion-text-center no-trades-label">
    <ion-label class="no-trades">{{ 'insights.no-trades-shown' | translate }}</ion-label>
  </div>
}